import axios from 'axios';
import { isUndNullEmp, responseGet } from '../../helpers/settings';
import { globalSettings } from '../../helpers/settings';

let result;
let dataObj = {};
let headers = {};

const { app, } = globalSettings;
const { backend, } = app;

export const condominiumBoardElectionResultsGetAsync = async ({
    id = '',
    buildingId = '',
    isResumen = false,
    auth = {},
    reportName = '',
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'condominiumBoardElectionResultsGetAsync';
    let response = responseGet();
    try {
        //#region initialize
        //#endregion initialize

        //#region variables
        dataObj = {
            buildingId: buildingId,
            //id: id,
            condominiumBoardElectionId: id,
            //userId: auth?.user?.uid,
            isResumen: isResumen,
            //method: globalSettings?.collections?.condominiumBoardElections,
            method: backend?.methods?.condominiumBoardElectionResults,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/`,
            languageId: languageId,
        };
        //#endregion variables

        //#region get data
        headers = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headers,
        );
        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
        //#endregion get data

        //#region Report open
        window?.open(`/${reportName}/${response?.result?.id}`, '_blank');
        //#endregion Report open
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
        console?.error(response);
    }
    return response;
}